// viewer 内で共有する小さな純粋関数群。DOM に依存しない。

// 値を [lo, hi] にクランプする。
export function clamp(v: number, lo: number, hi: number): number {
  return Math.min(Math.max(v, lo), hi);
}

// "42.5%" や "42.5" のような文字列を数値に変換する。不正値は 0。
export function parsePct(v: string): number {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
}
